import { useEffect, useState } from 'react'
import { Platform } from 'react-native'

/**
 * En web (master-detail) la lista vive en el navegador interno y el detalle se abre en el
 * stack de afuera, a la derecha. Devuelve el parámetro `param` del detalle `routeName` que
 * esté abierto (ej. el uuid del comunicado), para marcar esa fila como seleccionada.
 * En la app no hay columnas, así que siempre devuelve undefined.
 * sameStack: la lista ya es un detail del stack de afuera (ej. comprobantes, cuyo validador
 * se abre en la tercera columna), así que se observa su propio navegador, no el padre.
 */
export default function useOpenDetailParam(navigation: any, routeName: string, param: string, sameStack = false): string | undefined {
  const parent = Platform.OS === 'web' ? (sameStack ? navigation : navigation.getParent()) : undefined
  const pick = (state: any) => [...(state?.routes ?? [])].reverse()
    .find((r: any) => r.name === routeName)?.params?.[param]
  const [value, setValue] = useState<string | undefined>(() => pick(parent?.getState()))

  useEffect(() => {
    if (!parent) return
    setValue(pick(parent.getState()))
    return parent.addListener('state', (e: any) => setValue(pick(e.data.state)))
  }, [parent, routeName, param])

  return value
}
